export enum DisplayMode {
	'Inline' = 'inline',
	'InlineManufacturing' = 'inline-manufacturing',
	'Overhead' = 'overhead',
	'Panel' = 'panel',
	'Manufacturing' = 'manufacturing',
	'OverheadManufacturing' = 'overhead-manufacturing',
	'Backsplash' = 'backsplash',
	'BacksplashManufacturing' = 'backsplash-manufacturing',
	'CornerTrim' = 'corner-trim',
	'CornerTrimManufacturing' = 'corner-trim-manufacturing',
	'SkuOverhead' = 'sku-overhead',
	'SkuOverheadManufacturing' = 'sku-overhead-manufacturing',
	'BlueprintView' = 'blueprint-view'
}
